import {
  ROLE_PLATFORM_HIXME_ADMIN,
  ROLE_BROKER,
  ROLE_CLIENT_ADMIN,
} from '@hixme/role-policy'
import { selectors as authSelectors } from '@hixme/auth-ui'
import authOnEnter from 'modules/auth-on-enter'
import { adminShellOnEnter } from 'enrollment-platform/rbac/adminShellOnEnter'
import AdminLayout from 'layouts/AdminLayout/AdminLayoutContainer'
import AuthenticatedRoute from 'layouts/AuthenticatedRoute/AuthenticatedRouteContainer'
import Home from './Home'
import platformRoutes from '../enrollment-platform/routes'

const adminRoutes = (store) => ({
  component: AdminLayout,
  path: '/',
  title: 'Home',
  indexRoute: Home,
  onEnter(nextState, replace, callback) {
    const role = authSelectors.getRole(store.getState())
    // Role not hydrated yet on fresh load: skip the coarse role check (it would
    // 401 -> 404) but still apply the ability floor — it resolves /me/ability
    // itself and doesn't depend on the Redux role.
    if (!role) {
      adminShellOnEnter(nextState, replace, callback)
      return
    }
    store.dispatch(
      authOnEnter({
        allowedRoles: [
          ROLE_PLATFORM_HIXME_ADMIN,
          ROLE_CLIENT_ADMIN,
          ROLE_BROKER,
        ],
        callback: (err) =>
          err ? callback(err) : adminShellOnEnter(nextState, replace, callback),
      })
    )
  },
  getChildRoutes(_, next) {
    require.ensure([], (require) => {
      const routes = [require('./Home').default].concat(
        require('./ApplicationManager').default(store),
        require('./ApplicationEngine').default(store),
        require('./Expenses').default(store),
        require('./Census').default(store),
        require('./Company').default(store),
        require('./DigitalMailManagement').default(store),
        require('./Employees').default(store),
        require('./EmployeeReport').default(store),
        require('./EnrollmentDashboard').default(store),
        require('./HealthPlans').default(store),
        require('./ProspectsV2').default(store),
        require('./QuotingV2_1/prospects').default(store),
        require('./Analytics').default(store),
        require('./Tools').default(store),
        require('./Censory').default(store),
        require('./Profile').default(store),
        require('./DataAndReports').default(store),
        require('./DocumentCenter').default(store),
        require('./LifeEvents').default(store),
        require('./QualifyingLifeEvent').default(store),
        require('./QualifyingLifeEvent/routes/QLEDetail').default(store),
        require('./OpenEnrollment').default(store),
        require('./Recruiting').default(store),
        // TEMPORARY — EMS-10086, no nav entry
        // Remove this line + the AbpUploadDashboard/ folder once retired.
        require('./AbpUploadDashboard/route').default(store),
        ...platformRoutes()
      )
      next(null, routes)
    })
  },
})

const popOutRoutes = (store) => ({
  component: AuthenticatedRoute,
  getChildRoutes(_, next) {
    require.ensure([], (require) => {
      const routes = [
        require('./ApplicationManager/routes/ApplicationDetail').default(store),
        require('./LifeEvents/QLERecordPopupView/route').default(store),
      ]
      next(null, routes)
    })
  },
})

export const createRoutes = (store) => {
  const routes = {
    getChildRoutes(_, next) {
      require.ensure([], (require) => {
        const childRoutes = [adminRoutes(store), popOutRoutes(store)].concat(
          require('./Auth').default(store),
          require('./Onboarding').default(store),
          require('./QuotingV2').default(store),
          require('./QuotingV2_1').default(store),
          require('./NotFound').default(store)
        )
        next(null, childRoutes)
      })
    },
  }
  return routes
}

export default createRoutes
